export default function StripeRule({ className = "" }) {
  return (
    <div className={`stripe-rule ${className}`} aria-hidden="true">
      <span /><span /><span /><span /><span />
    </div>
  );
}
